import { NgModule } from '@angular/core'

import { DynamicMomentPipe } from './dynamic-moment.pipe'

@NgModule({
	declarations: [DynamicMomentPipe],
	imports: [],
	exports: [DynamicMomentPipe],
})
export class DynamicMomentPipeModule {}
